export enum EMobileLanguageCurrencyColors {
  WHITE = `#fff`,
  GREY = `#888`,
}
